/* eslint-disable no-param-reassign,no-unused-vars */
/* global G */
import { curry } from 'lib/util'

/**
 * Clear And Reload List Event Handler
 *
 * Inspects the current group data to determine whether the published item was
 * changed by us (updated/deleted) or remote (added). Only if the latter is true
 * we wipe the list and repopulate it. We need to do this because with notifications,
 * we can't GET a single one, the api doesn't allow it. So if an item was added by
 * remote, we need to do a full cycle.
 *
 * @type Gaia.AppModule.EventHandler
 */
const clearAndReloadList = async (module, component, event) => {
  const { id = null } = event?.detail || event || {}

  const { namespace: groupName } = component[G.PROPS]
  const groupAdapter = module[G.ADAPTER][G.NOTIFICATION][G.GROUP][groupName]
  const { data: existingItems = [] } = groupAdapter[G.DATA]
  const wasUpdatedOrDeleted = existingItems.find(d => d.key === id)

  if (!wasUpdatedOrDeleted) {
    component[G.STATE].reload = {}
    component[G.STATE].data = null
    component[G.STATE].page = null
    module[G.ADAPTER][G.UI].update(module)
  }
}

export default curry(clearAndReloadList)
